import React, { useEffect, useState } from 'react'
import { useIsWinnerDeclared, useWinningPotDisplay, usePlayerData, useMultiPotAmounts } from './useGameTable';

export default function useWinnerHandStrength(tempTableId) {
	const isWinnerDeclared = useIsWinnerDeclared(tempTableId);
	const winningPotDisplay = useWinningPotDisplay(tempTableId);
	const playerData = usePlayerData(tempTableId);
	const multiPotAmounts = useMultiPotAmounts(tempTableId);
	const [splitPot, setSplitPot] = useState(false);
	const [multiPots, setMultiPots] = useState(false);
	const [handType, setHandType] = useState(null);

	useEffect(() => {
		if (isWinnerDeclared && winningPotDisplay) {
			//console.log('Spruha log >>> Getting Player Hand Type! ')
			getPlayerHandType();
		} else {
			//console.log('Spruha log >>> Unable to get player hand strength', isWinnerDeclared, winningPotDisplay);
			setHandType(null);
			setSplitPot(false);
			setMultiPots(false);
		}

	}, [isWinnerDeclared, winningPotDisplay]);

	const getPlayerHandType = () => {
		let playerName = winningPotDisplay?.winnerNames[0];
		let playerInformation = playerData?.find(
			(player, index) => player.userName === playerName
		);
		if (
			playerInformation &&
			playerInformation.isWinner &&
			playerInformation.handType
		) {
			//console.log('Spruha log >>> Setting hand type to >>> ', playerInformation?.handType)
			setHandType(playerInformation?.handType);
		}
		setSplitPot(winningPotDisplay?.winnerNames?.length > 1);
		if (multiPotAmounts?.length > 1) {
			setMultiPots(true);
		} else {
			setMultiPots(false);
		}
	};

	return { splitPot, multiPots, handType }
}
